
<template>
  <VueCtkDateTimePicker 
    label="Select Date Range"
    v-model="dateRange"
    output-format="YYYY-MM-DDTHH:mm:ss[Z]"
    format="YYYY-MM-DD"
    formatted="YYYY-MM-DD"
    :range="true"
    :dark="dark"
    :custom-shortcuts="shortcuts"
    @validate="clicked"
    :inline="inline"
    :auto-close="auto"
  ></VueCtkDateTimePicker>
</template>

<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
export default {
  props: {
    dark: {
      type: Boolean,
      required: false,
      default: false
    }, 
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    onclick: {
      type: Boolean,
      required: false,
      default: false
    },
    auto: {
      type: Boolean,
      required: false,
      default: false
    },
    initial: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }
  },
  data () {
    return {
      dateRange: {
        
      },
      shortcuts: [
        { key: 'today', label: 'Today', value: 'day'},
        { key: 'yesterday', label: 'Yesterday', value: '-day'},
        { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
    }
  },
  watch: {
    dateRange (val) {
      if (!this.onclick) this.$emit('daterange', val)
    }
  },
  methods: {
    clicked() {
      if (this.onclick) this.$emit('daterange', this.dateRange)
    }
  },
  mounted () {
    this.dateRange = this.initial
  }
}
</script>

<style scoped>

</style>
